import React from 'react';
import { useNavigate } from 'react-router-dom';

import Card from './components/card';
import withPagination from '../../hoc/with-pagination';
import { API, ROUTES } from '../../helpers/constants';
import LoadingListItem from './components/loading-list-item';

const Event = ({ data }) => {
  const navigate = useNavigate();

  return (
    <div className="w-full md:w-[80%] m-auto py-14">
      <div className="grid grid-cols-1 w-[80%] md:w-full md:grid-cols-2 mx-auto lg:grid-cols-4 gap-6">
        {data?.map((event) => (
          <Card
            title={event?.name}
            subtitle={event?.description}
            sourceImage={event?.['file_url']}
            onClick={() => navigate(`${ROUTES.event}/${event.id}`)}
          />
        ))}
      </div>
    </div>
  );
};

export default withPagination(Event, {
  api: `${process.env.REACT_APP_API_BASE_URL}/${API.events}?group=2`,
  queryKey: 'events',
  pageNumberLimit: 12,
  header: {
    title: 'Informasi Terbaru',
    subtitle:
      'Dapatkan informasi terbaru seputar kegiatan dan program menari dari Dinas Perhubungan Jawa Barat',
    button: {
      placeholder: 'Cari',
      id: 'search-event'
    }
  },
  loading: {
    renderItem: <LoadingListItem />,
    totalItem: 8,
    colItem: {
      sm: 1,
      md: 2,
      lg: 4
    }
  }
});
